import apis from '@/api'
import { ref  } from 'vue'

export default function usePosition() {
  const positionData = ref([])
  const positionTopNode = ref([])
  const posDetail = ref({})

  const initTree = (type) => {
    apis.queryPositionTree(type).then(res => {
      positionData.value = res.data
    })
  }

  const addPosition = (data) => {
    return apis.addPosition(data).then(() => {
      return Promise.resolve()
    }).catch(() => Promise.reject())
  }

  const editPosition = data => {
    return apis.editPosition(data).then(() => {
      return Promise.resolve()
    }).catch(() => Promise.reject())
  }
 
  const deletePosition = data => {
    return apis.deletePosition(data.id).then(() => {
      return Promise.resolve()
    }).catch(() => Promise.reject())
  }

  const queryPositionById = id => {
    return apis.queryPositionById(id).then(res => {
      posDetail.value = res.data?res.data:{}
    })
  }

  const queryPositionChild = id => {
    return apis.queryPositionChild(id).then(res => {
      res.data.forEach((val)=> {
        val.leaf = val.positionType === 2 ? 1 : 0;
        val.disabled = val.status === 0 ? true : false;
      })
      if(id){
        positionData.value = res.data
      }else{
        positionTopNode.value = res.data
      }
    })
  }

  return {
    positionData,
    positionTopNode,
    posDetail,
    initTree,
    addPosition,
    editPosition,
    deletePosition,
    queryPositionById,
    queryPositionChild
  }
}